import { getCookieToken } from 'helpers/nativeParams';

const REQUEST_TIMEOUT_MS = 20000;
const DEFAULT_LANGUAGE = 'en';

function getRequiredHeaders(): Record<string, string> {
    return {
        version: import.meta.env.VITE_MB_WEBVIEW_API_VERSION,
        'x-api-key': import.meta.env.VITE_MB_WEBVIEW_API_KEY,
        language: (navigator.language || DEFAULT_LANGUAGE).split('-')[0],
        platform: import.meta.env.PLATFORM_CODE,
    };
}

export class ApiError extends Error {
    status: number;

    constructor(status: number, message: string) {
        super(message);
        this.status = status;
    }
}

function assertRequiredHeaders(headers: Record<string, string>): void {
    const missingHeaders = Object.keys(headers).filter((header) => !headers[header]);

    if (missingHeaders.length > 0) {
        throw new Error(`Missing required header(s): ${missingHeaders.join(', ')}`);
    }
}

export async function fetchClient(path: string, init: RequestInit = {}): Promise<Response> {
    const requiredHeaders = getRequiredHeaders();

    assertRequiredHeaders(requiredHeaders);

    const url = new URL(path, import.meta.env.VITE_MB_WEBVIEW_API_URL);
    const token = getCookieToken();

    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), REQUEST_TIMEOUT_MS);

    try {
        const response = await fetch(url, {
            ...init,
            signal: controller.signal,
            headers: {
                ...requiredHeaders,
                ...(token && { token }),
                ...init.headers,
            },
        });

        if (!response.ok) {
            throw new ApiError(response.status, `Request to ${path} failed with status ${response.status}`);
        }

        return response;
    } finally {
        clearTimeout(timeoutId);
    }
}
